<div class="marv_img"
    [class.cover]="this.objectFit === 'cover'"
    [class.contain]="this.objectFit === 'contain'"
    >
    @if(this.isLoading){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>   
    }   
    <img [src]="(this.errorImg ? this.srcPictureError : this.src)" (load)="this.onLoad()" (error)="this.onError()"/>     
</div>